/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaOutboundOrderReqVo
 */
export interface KoreaOutboundOrderReqVo {
    /**
     * 请求类型
     * @type {number}
     * @memberof KoreaOutboundOrderReqVo
     */
    requestType?: number;
    /**
     * 本地运输方式ID  5 快递 6 货车 7官方揽收快递（ coupang纸箱）8 官方揽收托盘 9 官方整柜入库
     * @type {number}
     * @memberof KoreaOutboundOrderReqVo
     */
    krLocalTransportMethodId?: number;
    /**
     * 收人姓名
     * @type {string}
     * @memberof KoreaOutboundOrderReqVo
     */
    receiver?: string;
    /**
     * 唛头号
     * @type {string}
     * @memberof KoreaOutboundOrderReqVo
     */
    markNo?: string;
    /**
     * 出库运单号
     * @type {string}
     * @memberof KoreaOutboundOrderReqVo
     */
    ivc?: string;
    /**
     * coupang预约码
     * @type {string}
     * @memberof KoreaOutboundOrderReqVo
     */
    coupangInboundCode?: string;
    /**
     * coupang仓库ID
     * @type {number}
     * @memberof KoreaOutboundOrderReqVo
     */
    coupangWarehouseId?: number;
    /**
     * coupang入库日期
     * @type {string}
     * @memberof KoreaOutboundOrderReqVo
     */
    coupangInboundDate?: string;
    /**
     * 库位号
     * @type {string}
     * @memberof KoreaOutboundOrderReqVo
     */
    locationNo?: string;
}

/**
 * Check if a given object implements the KoreaOutboundOrderReqVo interface.
 */
export function instanceOfKoreaOutboundOrderReqVo(value: object): value is KoreaOutboundOrderReqVo {
    return true;
}

export function KoreaOutboundOrderReqVoFromJSON(json: any): KoreaOutboundOrderReqVo {
    return KoreaOutboundOrderReqVoFromJSONTyped(json, false);
}

export function KoreaOutboundOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaOutboundOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'krLocalTransportMethodId': json['krLocalTransportMethodId'] == null ? undefined : json['krLocalTransportMethodId'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'coupangWarehouseId': json['coupangWarehouseId'] == null ? undefined : json['coupangWarehouseId'],
        'coupangInboundDate': json['coupangInboundDate'] == null ? undefined : json['coupangInboundDate'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
    };
}

export function KoreaOutboundOrderReqVoToJSON(json: any): KoreaOutboundOrderReqVo {
    return KoreaOutboundOrderReqVoToJSONTyped(json, false);
}

export function KoreaOutboundOrderReqVoToJSONTyped(value?: KoreaOutboundOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestType': value['requestType'],
        'krLocalTransportMethodId': value['krLocalTransportMethodId'],
        'receiver': value['receiver'],
        'markNo': value['markNo'],
        'ivc': value['ivc'],
        'coupangInboundCode': value['coupangInboundCode'],
        'coupangWarehouseId': value['coupangWarehouseId'],
        'coupangInboundDate': value['coupangInboundDate'],
        'locationNo': value['locationNo'],
    };
}

